import config from '../config';

const previewHost = config.previewUrl;

export const createPreviewUrl = (documentUrl: string, width: number): string => {
  const documentUriEncoded = escape(documentUrl);

  return `${previewHost}?documentUri=${documentUriEncoded}&width=${width}&bgColor=transparent`;
};
